import type { IconSvgObject } from './types';

const KetupatIcon: IconSvgObject = [
  ["path", { d: "M19.0858 12.0858L13.4142 6.41421C12.6332 5.63316 11.3668 5.63317 10.5858 6.41421L4.91421 12.0858C4.13316 12.8668 4.13317 14.1332 4.91421 14.9142L10.5858 20.5858C11.3668 21.3668 12.6332 21.3668 13.4142 20.5858L19.0858 14.9142C19.8668 14.1332 19.8668 12.8668 19.0858 12.0858Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16.5 9L12 13.5M12 13.5L7.5 18M12 13.5L7.5 9M12 13.5L16.5 18", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15 2C12.5 2 12 5.5 12 5.5C12 5.5 11 3 9 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default KetupatIcon;
